import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {MatPaginator} from '@angular/material/paginator';
import {RegistrationIdImport} from '../../../shared/interface/registration-id-import';
import {interval, ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../../../shared/services/auth.service';
import {startWith, takeUntil, tap} from 'rxjs/operators';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {Uuid} from '../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../shared/components/job-result-dialog/job-result-dialog.component';
import {HttpErrorResponse} from '@angular/common/http';
import {SoldPolicyImportService} from '../../../shared/services/sold-policy-import.service';
import {SoldPolicyImport} from '../../../shared/interface/sold-policy-import';

@Component({
  selector: 'app-all-imports-list',
  templateUrl: './all-imports-list.component.html',
  styleUrls: ['./all-imports-list.component.scss']
})
export class AllImportsListComponent implements AfterViewInit, OnInit, OnDestroy {

  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  imports: SoldPolicyImport[] = [];
  displayedColumns: string[] = [
    'name', 'company', 'insuranceCompany', 'createdAt', 'createdBy', 'totalRows', 'status', 'actions'
  ];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private soldPolicyImportService: SoldPolicyImportService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.soldPolicyImportService.importListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<SoldPolicyImport>) => {
          this.imports = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
  }

  ngOnInit(): void {
    interval(5000)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        if (this.paginator.pageIndex === 0) {
          this.loadListData();
        }
      });
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        startWith(''),
        takeUntil(this.destroyed$)
      ).subscribe(() => this.loadListData());
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.soldPolicyImportService.loadImportList(this.paginator.pageIndex, this.paginator.pageSize, this.filtersForm.value);
  }

  filter(): void {
    if (this.paginator.pageIndex === 0) {
      this.loadListData();
    } else {
      this.paginator.firstPage();
    }
  }

  downloadReport(): void {
    this.soldPolicyImportService.downloadImportsReport(this.filtersForm.value)
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.loadListData();
  }

  onImgError($event: ErrorEvent): void {
    // @ts-ignore
    $event.target.src = '/assets/avatar.png';
  }

  downloadImportFile(registrationIdImport: RegistrationIdImport): void {
    this.soldPolicyImportService.downloadImportFile(registrationIdImport.uuid);
  }

}
